import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Markdown from "@configuratorware/configurator-frontendgui/Framework/Components/Markdown";

const useStyles = makeStyles(theme => ({
  root: {
    '& p': {
      margin: 0,
    },
    '& a': {
      color: theme.palette.primary.main
    }
  },
}));

const DescriptionContainer = (props) => {
  const [ref, setRef] = useState(null);
  useEffect(() => {
    if (!ref) {
      return;
    }
    const handleClick = (evt) => {
      if (evt.target.tagName.toLowerCase() === 'a') {
        const { href } = evt.target;
        evt.preventDefault();
        console.info('sending message to container window to open the following url:', href);
        window.parent && window.parent.postMessage && window.parent.postMessage(
          { method: 'openInformationDialog', url: href },
          '*'
        );
      }
    };
    ref.addEventListener('click', handleClick, true);
    return () => ref.removeEventListener('click', handleClick, true);
  }, [ref]);
  return <div ref={setRef} {...props} />;
}

export const ComponentDescription = ({ text, className }) => {
  const classes = useStyles();

  return (
    <Markdown
      MdComponent={Typography}
      variant="body2"
      component={DescriptionContainer}
      className={clsx(classes.root, className)}
    >
      {text}
    </Markdown>
  )
}

ComponentDescription.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
}

export default ComponentDescription;
